export type SidebarState = 'expanded' | 'collapsed';

const COOKIE_NAME = 'proadv.sidebar';
const ONE_YEAR = 60 * 60 * 24 * 365;

export function readSidebarCookie(): SidebarState {
  if (typeof document === 'undefined') return 'expanded';
  const match = document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${COOKIE_NAME}=`));
  if (!match) return 'expanded';
  const value = match.split('=')[1];
  return value === 'collapsed' || value === 'expanded' ? value : 'expanded';
}

export function writeSidebarCookieClient(state: SidebarState): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_NAME}=${state}; path=/; max-age=${ONE_YEAR}; SameSite=Lax`;
}

export const SIDEBAR_COOKIE_NAME = COOKIE_NAME;
